import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import patchRequest from './base/patch';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}
export default {
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingPointWithoutPagination: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point`, { ...data });
  },
  /**
   * Fetch average uptime and downtime statistics for charging stations
   */
  fetchAvgOnlineOffline: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/avg-uptime-downtime`,
      { ...data },
    );
  },
  /**
   *  All Devices show API
   */
  fetchDeviceList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/device-list`, {
      ...parameters,
    });
  },
  /**
   *  Station Activity show API
   */
  fetchStationActivityList: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/ocpp-logs`, {
      ...parameters,
    });
  },

  /**
   *  Station Activity show API
   */
  fetchStationActivityExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/ocpp-logs-export`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Station Activity show API
   */
  fetchStationActivityListFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/ocpp-logs/list-filters`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Station management's station details chart api
   * @param query
   * @returns
   */
  fetchStationChartData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/time-based-transaction-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Station management's station details data api
   * @param id
   * @returns
   */
  fetchStationDetails: (id: string) => {
    console.log('Getting ID:', id);
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/${id}`);
  },
  /**
   *  Station Activity show API
   */
  fetchConnectorStatus: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/connector-status`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchTransactionList: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-transaction`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchTransactionListFilter: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-transaction/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchTransactionListExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-transaction/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchTransactionChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/power-consumption-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchGuestChargingList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/free-charging-schedules`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchGuestChargingchart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/schedule-charging-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Guest charging filter
   * @param query
   * @returns
   */
  fetchGuestChargingListFilter: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/free-charging-schedules/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Guest charging
   * @param query
   * @returns
   */
  fetchGuestChargingListExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/free-charging-schedules/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchMaintenanceSchedule: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule`,
      {
        ...parameters,
      },
    );
  },
  /**
   * maintenance schedule export
   * @param query
   * @returns
   */
  fetchMaintenanceScheduleExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule/export-data`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Maintenance schedule filters
   * @param query
   * @returns
   */
  fetchMaintenanceScheduleFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule-report/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Transactions show API
   */
  fetchMaintenanceCalendars: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/maintenance-schedule-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab summary list with pagination
   */
  fetchReportSummary: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-report-overview`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab summary list with pagination
   */
  fetchReportSummaryExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-report-overview/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab summary list with pagination
   */
  fetchReportSummaryFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-report-overview/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Revenue & Energy Trends
   */
  fetchReportPowerConsumed: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-power-consumption`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Fetch the Report tab Revenue & Energy Trends
   */
  fetchRevenueChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/power-consumption-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   */
  fetchReportUtilization: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-utilization`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   */
  fetchReportUtilizationExport: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-utilization/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   */
  fetchReportUtilizationFilters: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-utilization/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching charging station list
   * @returns
   */
  fetchChargingStationList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-list`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   */
  fetchDevicesList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-point-list`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Edit schedule API add lane or edit lane api
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editLaneMap: (id: number | string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station-map/${id}`,
      data,
    );
  },
  /**
   * Fetch the Report tab Utilization & Efficiency list with pagination
   */
  fetchLaneMapList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-station-map`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Station performance tab Historical Faults list with pagination
   */
  fetchHistoricalFaultsList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/historical-fault-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching historical fault list filter
   */
  fetchHistoricalFaultsListFilter: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/historical-fault-report/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching historical fault list filter
   */
  fetchHistoricalFaultsListExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/historical-fault-report/export`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Station performance chart heat map hour
   */
  fetchHeatMapByHour: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/transaction-duration-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the station Compariosn tab Historical Faults list with pagination
   */
  fetchSessionCountPerStationChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/session-count-per-station`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the station Comparison  chart
   */
  fetchEnergyRevenueComparison: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-comparison-report`,
      {
        ...parameters,
      },
    );
  },
  /**
   * fetching heat map chart's data
   */
  fetchHeatMapChartData: () => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/transaction-duration-report`,
    );
  },
  /**
   *  Station Activity show API
   */
  fetchAlertsList: (query: QueryParameters) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/alerts`, {
      ...parameters,
    });
  },
  /**
   *  Alerts List show API
   */
  fetchAlertsExport: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/alerts-export`, {
      ...parameters,
    });
  },
  /**
   *  Alerts List Filters show API
   */
  fetchAlertsListFilters: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/alerts/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Alerts Chart show API
   */
  fetchAlertsChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-station/alerts-report`, {
      ...parameters,
    });
  },
  /**
   *  Alerts Chart show API
   */
  fetchAlertsPointInfo: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/alerts-charging-point-info`,
      {
        ...parameters,
      },
    );
  },

  /**
   *  Station performance uptime by station chart
   */
  fetchUptimeChartData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/uptime-by-station`,
      {
        ...parameters,
      },
    );
  },
  /**
   *  Station performance uptime by station chart
   */
  fetchUptimeOverTimeChartData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/uptime-trend-over-time`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetching no of schedules
   * @param query
   * @returns
   */
  fetchNoOfSchedules: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/station-schedule-hours`,
      { ...parameters },
    );
  },
  /**
   * Fetching no of Uptime list and chart
   * @param query
   * @returns
   */
  fetchUptimeListAndChart: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-consumption-month-wise`,
      { ...parameters },
    );
  },
  /**
   * Fetching today's uptime
   * @param query
   * @returns
   */
  fetUpTimeTodayData: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/charging-station-consumption-date-wise`,
      { ...parameters },
    );
  },
  /**
   *updating guest status
   * @returns
   */
  updateGuestStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/free-charging/updateActiveStatus/${id}`,
      data,
      false,
    );
  },
  /**
   *  Station Activity show API
   */
  fetchVehicleInformation: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-station/get-vehicle-information`,
      {
        ...parameters,
      },
    );
  },
};
